import { autoserialize, autoserializeAs } from 'cerialize';
import { Role } from './role';

export class UserRole {
  @autoserialize
  userId: number;

  @autoserializeAs(Role)
  role: Role;

  @autoserialize
  active: boolean;

  @autoserialize
  deactivationReasonId: number;
}
